<template>
  <div class="index">
    <!-- 搜索 -->
    <div class="wrap pt30 clearfix">
      <div class="con-t fr">
        <input v-model="searchStr2" @keyup.enter="searchFunc" type="text" class="con-t-input" placeholder="请输入搜索内容" />
        <div @click="searchFunc" class="con-t-searchbtn">
          <i class="el-icon-search"></i>
        </div>
      </div>
    </div>

    <!-- 1 通知公告，入口 -->
    <div class="wrap dflex pt20">
      <div class="flex-sub wow bounceInLeft" style="width: 0">
        <barTitle type="1" title="通知公告" linkUrl="/associationDynamic/noticeAnnouncement/list" />
        <div class="flex-sub m-list">
          <div
            v-for="(item, index) of list1"
            :key="index"
            @click="itemLinkTo(item, `/associationDynamic/noticeAnnouncement/info/${item.id}`)"
            class="m-list-item flex mt20"
          >
            <div class="flex-sub m-list-item-title flex" :title="item.title">
              <div class="elli flex-sub" style="width: 0">{{ item.title }}</div>
              <img v-if="item.label == '0'" class="ml10" src="/static/image/index/icon_totop.png" />
            </div>
            <div class="ml30 ml10 m-list-item-time">{{ item.releaseTime || item.updateTime }}</div>
          </div>
        </div>
      </div>
      <img
        @click="pageToAdmin"
        class="cursor-pointer wow bounceInRight"
        src="/static/image/index/tologin.png"
        alt=""
        style="height: 354px; margin-left: 60px"
      />
    </div>
    <!-- 2 协会活动 -->
    <div class="wrap dflex mt50">
      <!-- banner -->
      <div class="m-banner mr30 wow bounceInLeft" style="width: 600px">
        <el-carousel ref="list2Banner" @change="list2BannerChange" height="360px" arrow="never" :interval="6000" indicator-position="none">
          <el-carousel-item v-for="(item, index) of list2Banner" :key="index" :name="index + ''">
            <div class="image imgHover">
              <img
                class="img cursor-pointer"
                :src="item.titleImg"
                @click="itemLinkTo(item, `/associationDynamic/associationActivities/info/${item.id}`)"
                alt=""
                style="width: 600px; height: 360px"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="bar">
          <div class="bar-bg"></div>
          <div class="bar-con">
            <div
              class="bar-title elli fl"
              v-if="list2Banner.length > 0"
              @click="
                itemLinkTo(
                  list2Banner[parseInt(list2BannerIndex)],
                  `/associationDynamic/associationActivities/info/${list2Banner[parseInt(list2BannerIndex)].id}`
                )
              "
            >
              {{ list2Banner[parseInt(list2BannerIndex)].title }}
            </div>
            <div class="bar-circle fr">
              <div
                v-for="(item, index) in list2Banner"
                :key="index"
                @click="list2BannerCircleClick(index)"
                :class="'bar-circle-item ' + (list2BannerIndex == index ? 'active' : '')"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="flex-sub wow bounceInRight" style="width: 0">
        <barTitle type="1" title="协会活动" linkUrl="/associationDynamic/associationActivities/list" />
        <div class="flex-sub m-list">
          <div
            v-for="(item, index) of list2"
            :key="index"
            @click="itemLinkTo(item, `/associationDynamic/associationActivities/info/${item.id}`)"
            class="m-list-item flex mt20"
          >
            <div class="flex-sub elli m-list-item-title mr30" :title="item.title">{{ item.title }}</div>
            <img v-if="item.label == '0'" class="mr10" src="/static/image/index/icon_totop.png" />
            <div class="m-list-item-time">{{ item.releaseTime || item.updateTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 3 会员活动，培训考察  -->
    <div class="wrap dflex mt50">
      <div class="flex-sub m-bar pt20 pb10 itemboxHeight wow bounceInLeft" style="width: 0">
        <barTitle type="2" title="会员活动" linkUrl="/memberDynamics/memberActivities/list" />
        <div class="dflex pl20 pr20 pt30">
          <div class="flex-sub m-list" style="width: 0">
            <div
              v-for="(item, index) of list31"
              :key="index"
              @click="itemLinkTo(item, `/memberDynamics/memberActivities/info/${item.id}`)"
              class="m-list-item flex mb10 fs14"
            >
              <div class="flex-sub elli m-list-item-title mr30" :title="item.title">{{ item.title }}</div>
              <img v-if="item.label == '0'" class="mr10" src="/static/image/index/icon_totop.png" />
              <div class="m-list-item-time">{{ item.releaseTime || item.updateTime }}</div>
            </div>
          </div>
          <div class="m-banner ml30 self-start" style="width: 337px; height: 278px">
            <el-carousel
              ref="list31Banner"
              @change="list31BannerChange"
              height="278px"
              arrow="never"
              :interval="6000"
              indicator-position="none"
            >
              <el-carousel-item v-for="(item, index) of list31Banner" :key="index" :name="index + ''">
                <div class="image imgHover">
                  <img
                    @click="itemLinkTo(item, `/associationDynamic/associationActivities/info/${item.id}`)"
                    class="img cursor-pointer"
                    :src="item.titleImg"
                    alt=""
                    style="width: 337px; height: 278px"
                  />
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="bar">
              <div class="bar-bg"></div>
              <div class="bar-con">
                <div
                  class="bar-title elli fl"
                  v-if="list31Banner.length > 0"
                  @click="
                    itemLinkTo(
                      list31Banner[parseInt(list31BannerIndex)],
                      `/associationDynamic/associationActivities/info/${list31Banner[parseInt(list31BannerIndex)].id}`
                    )
                  "
                >
                  {{ list31Banner[parseInt(list31BannerIndex)].title }}
                </div>
                <div class="bar-circle fr">
                  <div
                    v-for="(item, index) in list31Banner"
                    :key="index"
                    @click="list31BannerCircleClick(index)"
                    :class="'bar-circle-item ' + (list31BannerIndex == index ? 'active' : '')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 培训考察 -->
      <div class="ml30 m-bar pt20 itemboxHeight wow bounceInRight" style="width: 380px">
        <barTitle type="2" title="培训考察" linkUrl="/trainingInvestigation/list" />

        <div class="m-list pt30 pl20 pr20">
          <div
            v-for="(item, index) of list32"
            :key="index"
            @click="itemLinkTo(item, `/trainingInvestigation/info/${item.id}`)"
            class="m-list-item flex mb10 fs14"
          >
            <div class="flex-sub elli m-list-item-title" :title="item.title">{{ item.title }}</div>
            <img v-if="item.label == '0'" class="ml30" src="/static/image/index/icon_totop.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 4 时事纵览 政府动态 党团活动 -->
    <div class="wrap dflex mt50">
      <div class="flex-sub m-bar pt20 pb10 itemboxHeight wow bounceInLeft" style="width: 0">
        <barTitle type="2" title="时事纵览" linkUrl="/encyclopediaOverview/currentAffairsSurvey/list" />
        <div class="m-list pt30 pl20 pr20">
          <div
            v-for="(item, index) of list41"
            :key="index"
            @click="itemLinkTo(item, `/encyclopediaOverview/currentAffairsSurvey/info/${item.id}`)"
            class="m-list-item flex mb10 fs14"
          >
            <div class="flex-sub elli m-list-item-title" :title="item.title">{{ item.title }}</div>
            <img v-if="item.label == '0'" class="ml30" src="/static/image/index/icon_totop.png" />
          </div>
        </div>
      </div>
      <div class="flex-sub ml30 m-bar pt20 pb10 itemboxHeight" style="width: 0">
        <barTitle type="2" title="政府动态" linkUrl="/governmentCommunity/governmentDynamics/list" />
        <div class="m-list pt30 pl20 pr20">
          <div
            v-for="(item, index) of list42"
            :key="index"
            @click="itemLinkTo(item, `/governmentCommunity/governmentDynamics/info/${item.id}`)"
            class="m-list-item flex mb10 fs14"
          >
            <div class="flex-sub elli m-list-item-title" :title="item.title">{{ item.title }}</div>
            <img v-if="item.label == '0'" class="ml30" src="/static/image/index/icon_totop.png" />
          </div>
        </div>
      </div>
      <div class="flex-sub ml30 m-bar pt20 pb10 itemboxHeight wow bounceInRight" style="width: 0">
        <barTitle type="2" title="党团活动" linkUrl="/partyActivityMain/partyActivity/list" />
        <div class="m-list pt30 pl20 pr20">
          <div
            v-for="(item, index) of list43"
            :key="index"
            @click="itemLinkTo(item, `/partyActivityMain/partyActivity/info/${item.id}`)"
            class="m-list-item flex mb10 fs14"
          >
            <div class="flex-sub elli m-list-item-title" :title="item.title">{{ item.title }}</div>
            <img v-if="item.label == '0'" class="ml30" src="/static/image/index/icon_totop.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 5 外埠协会 会员展示 物业常识 -->
    <div class="wrap dflex mt50">
      <div class="flex-sub m-bar pt20 pb10 itemboxHeight wow bounceInLeft" style="width: 0">
        <barTitle type="2" title="外埠协会" linkUrl="/foreignPortAssociation/list" />
        <div class="m-list pt30 pl20 pr20">
          <div
            v-for="(item, index) of list51"
            :key="index"
            @click="itemLinkTo(item, `/foreignPortAssociation/info/${item.id}`)"
            class="m-list-item flex mb10 fs14"
          >
            <div class="flex-sub elli m-list-item-title" :title="item.title">{{ item.title }}</div>
            <img v-if="item.label == '0'" class="ml30" src="/static/image/index/icon_totop.png" />
          </div>
        </div>
      </div>
      <div class="flex-sub ml30 m-bar pt20 pb10 itemboxHeight" style="width: 0">
        <barTitle type="2" title="会员展示" linkUrl="/memberDynamics/memberDisplay/list" />
        <div class="m-list pt30 pl20 pr20">
          <div
            v-for="(item, index) of list52"
            :key="index"
            @click="itemLinkTo(item, `/memberDynamics/memberDisplay/info/${item.id}`)"
            class="m-list-item flex mb10 fs14"
          >
            <div class="flex-sub elli m-list-item-title" :title="item.title">{{ item.title }}</div>
            <img v-if="item.label == '0'" class="ml30" src="/static/image/index/icon_totop.png" />
          </div>
        </div>
      </div>
      <div class="flex-sub ml30 m-bar pt20 pb10 itemboxHeight wow bounceInRight" style="width: 0">
        <barTitle type="2" title="物业常识" linkUrl="/encyclopediaOverview/propertyKnowledge/list" />
        <div class="m-list pt30 pl20 pr20">
          <div
            v-for="(item, index) of list53"
            :key="index"
            @click="itemLinkTo(item, `/encyclopediaOverview/propertyKnowledge/info/${item.id}`)"
            class="m-list-item flex mb10 fs14"
          >
            <div class="flex-sub elli m-list-item-title" :title="item.title">{{ item.title }}</div>
            <img v-if="item.label == '0'" class="ml30" src="/static/image/index/icon_totop.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 6 服务感动瞬间系列活动 -->
    <!-- <img class="cursor-pointer mt50" src="/static/image/index/wyds.png" alt="" style="width: 100%" /> -->
    <!-- 7 生活百科 诚信仲裁 视频 -->
    <div class="wrap dflex mt50">
      <div class="flex-sub m-bar pt20 pb10 itemboxHeight wow bounceInLeft" style="width: 0">
        <barTitle type="2" title="生活百科" linkUrl="/encyclopediaOverview/householdEncyclopedia/list" />
        <div class="m-list pt30 pl20 pr20">
          <div
            v-for="(item, index) of list61"
            :key="index"
            @click="itemLinkTo(item, `/encyclopediaOverview/householdEncyclopedia/info/${item.id}`)"
            class="m-list-item flex mb10 fs14"
          >
            <div class="flex-sub elli m-list-item-title" :title="item.title">{{ item.title }}</div>
            <img v-if="item.label == '0'" class="ml30" src="/static/image/index/icon_totop.png" />
          </div>
        </div>
      </div>
      <div class="flex-sub ml30 m-bar pt20 pb10 itemboxHeight" style="width: 0">
        <barTitle type="2" title="诚信仲裁" linkUrl="/goodFaithArbitration/goodFaithArbitrationList/list" />
        <div class="m-list pt30 pl20 pr20">
          <div
            v-for="(item, index) of list62"
            :key="index"
            @click="itemLinkTo(item, `/goodFaithArbitration/goodFaithArbitrationList/info/${item.id}`)"
            class="m-list-item flex mb10 fs14"
          >
            <div class="flex-sub elli m-list-item-title" :title="item.title">{{ item.title }}</div>
            <img v-if="item.label == '0'" class="ml30" src="/static/image/index/icon_totop.png" />
          </div>
        </div>
      </div>
      <div class="flex-sub ml30 m-bar pt20 pb10 itemboxHeight wow bounceInRight" style="width: 0">
        <barTitle type="2" title="视频" linkUrl="/video/list" />
        <div class="pt30 pl20 pr20">
          <video v-if="videoUrl" width="340" height="278" controls>
            <source :src="videoUrl" type="video/mp4" />
            <!-- <source src="https://hrbwyxh.oss-cn-beijing.aliyuncs.com/web/img/article_1634614750320.mp4" type="video/mp4" /> -->
            <!-- <source ：src="videoUrl" type="video/ogg" /> -->
            您的浏览器不支持 video 标签。
          </video>
        </div>
      </div>
    </div>
    <!-- 8 物业报 招标公告 中标公示 -->
    <div class="wrap dflex mt50">
      <div class="flex-sub m-bar pt20 pb10 itemboxHeight wow bounceInLeft" style="width: 0">
        <barTitle type="2" title="物业报" linkUrl="/propertyReport/list" />
        <div class="dflex pt30 pl20 pr20">
          <!-- {{ wybImg }} -->
          <el-image style="width: 203px; height: 276px" :preview-src-list="[wybImg]" :src="wybImg" alt=""></el-image>
          <div class="flex-sub m-list ml20" style="width: 0">
            <div @click="wybItemClick(item)" v-for="(item, index) of list71" :key="index" class="m-list-item flex mb10 fs14">
              <div class="flex-sub elli m-list-item-title" :title="item.title">{{ item.title }}</div>
              <img v-if="item.label == '0'" class="ml30" src="/static/image/index/icon_totop.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="flex-sub ml30 m-bar pt20 pb10 itemboxHeight" style="width: 0">
        <barTitle type="2" title="招标公告" linkUrl="/bidWinning/biddingAnnouncement/list" />
        <div class="m-list pt30 pl20 pr20">
          <div
            v-for="(item, index) of list72"
            :key="index"
            @click="itemLinkTo(item, `/bidWinning/biddingAnnouncement/info/${item.id}`)"
            class="m-list-item flex mb10 fs14"
          >
            <div class="flex-sub elli m-list-item-title" :title="item.title">{{ item.title }}</div>
            <img v-if="item.label == '0'" class="ml30" src="/static/image/index/icon_totop.png" />
          </div>
        </div>
      </div>
      <div class="flex-sub ml30 m-bar pt20 pb10 itemboxHeight wow bounceInRight" style="width: 0">
        <barTitle type="2" title="中标公示" linkUrl="/bidWinning/winningTheBidPublicity/list" />
        <div class="m-list pt30 pl20 pr20">
          <div
            v-for="(item, index) of list73"
            :key="index"
            @click="itemLinkTo(item, `/bidWinning/winningTheBidPublicity/info/${item.id}`)"
            class="m-list-item flex mb10 fs14"
          >
            <div class="flex-sub elli m-list-item-title" :title="item.title">{{ item.title }}</div>
            <img v-if="item.label == '0'" class="ml30" src="/static/image/index/icon_totop.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 9 友情链接 -->
    <div class="wrap mt50">
      <div class="index-yqlj flex">
        <div class="index-yqlj-left flex-sub">友情链接</div>
        <img
          @click="linkTo(item.linkUrl)"
          v-for="(item, index) of yqljList"
          :key="index"
          class="cursor-pointer ml20"
          :src="item.imgUrl"
          :title="item.name"
          alt=""
        />

        <!-- <el-carousel :interval="5000" arrow="always">
          <el-carousel-item v-for="item in 4" :key="item">
            <h3>{{ item }}</h3>
          </el-carousel-item>
        </el-carousel> -->
      </div>
    </div>
    <indexTip v-if="isDesktop()" />
  </div>
</template>

<script>
import { mixinDevice } from '@/util/mixin'
import { mapGetters } from 'vuex'

// 接口
import {
  findArticleByColIds, // 批量获取列表
  findArticlePage, // 获取列表
  findVideoPage, // 视频列表
} from '@/api/index'
// 工具
import { isNull } from '@/util/index'
// 组件
import barTitle from '@/components/barTitle'
import indexTip from './indexTip'
export default {
  mixins: [mixinDevice],
  components: {
    barTitle,
    indexTip,
  },
  data() {
    return {
      searchStr2: '',
      // 列表
      list1: [], // 通知公告 72
      list2Banner: [], // 3
      list2BannerIndex: 0,
      list2: [], // 协会活动 73

      list31: [], // 会员活动 79
      list31Banner: [], // 3
      list31BannerIndex: 0,
      list32: [], // 培训考察 76

      list41: [], // 时事纵览 84
      list42: [], // 政府动态 81
      list43: [], // 党团活动99

      list51: [], // 外埠协会 94
      list52: [], // 会员展示 78
      list53: [], // 物业常识 85

      list61: [], // 生活百科 86
      list62: [], // 诚信仲裁 90
      list63: [], // 视频 95  video  1
      videoUrl: '', // 视频链接

      list71: [], // 物业报 96 propertyReport
      wybImg: '',
      list72: [], // 招标公告 88
      list73: [], // 中标公示 89
      // 9 友情链接
      yqljList: [
        {
          name: '中国物业管理协会',
          imgUrl: '/static/image/index/friendship_link_1.png',
          linkUrl: 'http://www.ecpmi.org.cn/',
        },
        {
          name: '成都物业',
          imgUrl: '/static/image/index/friendship_link_2.png',
          linkUrl: 'https://www.cdpma.cn/',
        },
        {
          name: '深圳市物业管理行业协会',
          imgUrl: '/static/image/index/friendship_link_3.png',
          linkUrl: 'http://www.szpmi.org/',
        },
        {
          name: '沈阳市物业管理协会',
          imgUrl: '/static/image/index/friendship_link_4.png',
          linkUrl: 'http://www.sypma.com/',
        },
        {
          name: '武汉市物业管理协会',
          imgUrl: '/static/image/index/friendship_link_5.png',
          linkUrl: 'http://www.warpm.cn/',
        },
      ],
    }
  },
  created() {
    this.getList1()
    this.getList2()
    this.getVideoList()
  },
  computed: {
    // ...mapGetters(['winScroll']),
  },
  watch: {},
  mounted() {
    let wow = new WOW({
      animateClass: 'animated',
      offset: 0,
      callback: function (box) {
        console.log('WOW: animating <' + box.tagName.toLowerCase() + '>')
      },
    })
    wow.init()
  },
  methods: {
    pageToAdmin() {
      window.open('https://www.hrbwyxh.cn/')
    },
    // 新闻跳转详情
    itemLinkTo(item, url) {
      window.sessionStorage.pageData = JSON.stringify(item)
      this.$router.push({ path: url })
    },
    // 获取列表 获取前两行
    getList1() {
      let keyMap = [
        { id: '72', pageListKey: 'list1' }, // 通知公告
        { id: '73', pageListKey: 'list2' }, // 协会活动
      ]
      let idArr = []
      for (let item of keyMap) {
        idArr.push(item.id)
      }
      let sendObj = {
        colIds: idArr.join(','),
        page: 1,
        limit: 8,
      }
      findArticleByColIds(sendObj).then((res) => {
        console.log('res111', res)
        if (res.code == 200) {
          for (let item of keyMap) {
            let resList = res.data[`article${item.id}`]
            for (let itemResList of resList) {
              if (itemResList.releaseTime) itemResList.releaseTime = itemResList.releaseTime.substr(0, 10)
              if (itemResList.updateTime) itemResList.updateTime = itemResList.updateTime.substr(0, 10)
            }
            this[item.pageListKey] = resList
          }

          // banner
          let len = res.data.article73.length > 3 ? 3 : res.data.article73.length
          let list2Banner = []
          for (let i = 0; i < len; i++) {
            console.log('')
            list2Banner.push(res.data.article73[i])
          }
          this.list2Banner = list2Banner
        }
      })
    },
    // 获取其他
    getList2() {
      let keyMap = [
        { id: '79', pageListKey: 'list31' }, // 会员活动
        { id: '76', pageListKey: 'list32' }, // 培训考察

        { id: '84', pageListKey: 'list41' }, // 时事纵览
        { id: '81', pageListKey: 'list42' }, // 政府动态
        { id: '99', pageListKey: 'list43' }, // 党团活动

        { id: '94', pageListKey: 'list51' }, // 外埠协会
        { id: '78', pageListKey: 'list52' }, // 会员展示
        { id: '85', pageListKey: 'list53' }, // 物业常识

        { id: '86', pageListKey: 'list61' }, // 生活百科
        { id: '90', pageListKey: 'list62' }, // 诚信仲裁
        // { id: '84', pageListKey: 'list61' }, // 视频

        { id: '96', pageListKey: 'list71' }, // 物业报
        { id: '88', pageListKey: 'list72' }, // 招标公告
        { id: '89', pageListKey: 'list73' }, // 中标公示
      ]
      let idArr = []
      for (let item of keyMap) {
        idArr.push(item.id)
      }
      let sendObj = {
        colIds: idArr.join(','),
        page: 1,
        limit: 9,
      }
      findArticleByColIds(sendObj).then((res) => {
        console.log('res111', res)
        if (res.code == 200) {
          for (let item of keyMap) {
            // this[item.pageListKey] = res.data[`article${item.id}`]

            let resList = res.data[`article${item.id}`]
            for (let itemResList of resList) {
              if (itemResList.releaseTime) itemResList.releaseTime = itemResList.releaseTime.substr(0, 10)
              if (itemResList.updateTime) itemResList.updateTime = itemResList.updateTime.substr(0, 10)
            }
            this[item.pageListKey] = resList
          }

          let len = res.data.article79.length > 3 ? 3 : res.data.article79.length
          let list31Banner = []
          for (let i = 0; i < len; i++) {
            list31Banner.push(res.data.article79[i])
          }
          this.list31Banner = list31Banner

          this.wybImg = this.list71[0].titleImg
        }
      })
    },
    // 视频
    getVideoList() {
      let sendObj = {
        label: '',
        page: 1,
        limit: 1,
      }
      findVideoPage(sendObj).then((res) => {
        if (res.code == 200) {
          let list = res.data ? res.data : []
          if (list.length > 0) {
            this.videoUrl = list[0].flvUrl
          }
        }
      })
    },

    // --
    // 2 协会活动切换
    list2BannerChange(val) {
      this.list2BannerIndex = val
    },
    list2BannerCircleClick(index) {
      this.$refs['list2Banner'].setActiveItem(index + '')
      this.list2BannerIndex = index + ''
    },

    // 3 会员活动
    list31BannerChange(val) {
      this.list31BannerIndex = val
    },
    list31BannerCircleClick(index) {
      this.$refs['list31Banner'].setActiveItem(index + '')
      this.list31BannerIndex = index + ''
    },
    // 8 物业包
    wybItemClick(item) {
      this.wybImg = item.titleImg
    },

    // ---
    // 跳转页面
    linkTo(url) {
      window.open(url)
    },
    pageTo(url) {
      this.$router.push({ path: url })
    },
    searchFunc() {
      window.sessionStorage.pageSearchStr = this.searchStr2
      this.$router.push(`/searchPage/list`)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.index {
  background: #fff;
  padding-bottom: 50px;
}

// 友情链接
.index-yqlj {
  border-top: 1px solid #dfdfdf;
  border-bottom: 1px solid #dfdfdf;
  padding: 50px 0;
  .index-yqlj-left {
    font-size: 34px;
    color: #000;
    font-weight: 400;
  }
}
.itemboxHeight {
  height: 382px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue